import { FC, useState, useEffect, useRef } from 'react';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import './editor-custom.css';

interface EditorComponentProps {
  value: string;
  onChange: (value: string) => void;
  toolbar?: object;
}

export const EditorComponent: FC<EditorComponentProps> = ({
  value = '',
  onChange,
  toolbar,
}) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const lastHtmlRef = useRef('');

  useEffect(() => {
    if (value !== lastHtmlRef.current) {
      try {
        const contentBlock = htmlToDraft(value);

        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks,
            contentBlock.entityMap
          );
          const newEditorState = EditorState.createWithContent(contentState);

          if (
            draftToHtml(convertToRaw(newEditorState.getCurrentContent())) !==
            draftToHtml(convertToRaw(editorState.getCurrentContent()))
          ) {
            setEditorState(newEditorState);
            lastHtmlRef.current = value;
          }
        }
      } catch (error) {
        console.error('Error converting HTML to editor state:', error);
      }
    }
  }, [value, editorState]);

  const handleEditorChange = (state: EditorState) => {
    setEditorState(state);
    const rawContentState = convertToRaw(editorState.getCurrentContent());

    const html = draftToHtml(rawContentState);

    lastHtmlRef.current = html;

    onChange(html);
  };

  return (
    <div>
      <Editor
        editorClassName="demo-editor border p-2 rounded-[3px] min-h-[400px]"
        editorState={editorState}
        handlePastedText={() => false}
        toolbar={toolbar}
        toolbarClassName="rdw-storybook-toolbar"
        wrapperClassName="demo-wrapper"
        onEditorStateChange={handleEditorChange}
      />
    </div>
  );
};
